import http from 'axios'
import OAuth from '../oauth/index'
import store from '../store/index'
import router from "../router";
import {CLIENT_SECRET, BASE_URL} from "../config/config";

let refreshSubscribers = [];


let oauth_url = BASE_URL + '/oauth/token';
let no_of_request = 0;
let oAuth = new OAuth();
let errorFunction = error => {
    if (error.request.status === 0 || error.request.status === 500) {
        store.commit("Notification/showError", "Something went wrong.");
        return Promise.reject(error)
    }

    if (error.response.status === 422) {
        store.commit("Notification/showError", error.response.data.message);
    }
    if (error.response.status === 403) {
        store.commit("Notification/showError", "Unauthorized access");
    }
    if (error.response.status === 429) {
        store.commit("Notification/showError", error.response.data.message);
    }
    const originalRequest = error.config;
    if (error.response.status === 401) {
        if (refreshSubscribers.length === 0) {
            refreshToken().then((res) => {
                onRefreshed(res);
            })
        }

        return new Promise((resolve) => {
            return subscribeTokenRefresh(token => {
                resolve(http(originalRequest));
            });
        });
    } else {
        console.log(error);
        return Promise.reject(error);
    }

};
// Add a request interceptor
http.interceptors.request.use((config) => {

    if (oAuth.isAuthenticated()) {
        config.headers['Authorization'] = oAuth.getAuthHeader() //Example: Bearer asf3132dfsfddffd
    }
    window.localStorage.setItem('last_requested', new Date());


    return config;
}, (error) => {
    // Do something with request error
    return Promise.reject(error);
});


// Add a response interceptor
const response_interceptor = http.interceptors.response.use(function (response) {

    if (response.config.url !== oauth_url)
        no_of_request++;


    return response;
}, async error => {


    if (window.location.pathname !== '/admin/login') {
        return await errorFunction(error);
    }


    return Promise.reject(error);
});


function subscribeTokenRefresh(cb) {
    return refreshSubscribers.push(cb);
}

function onRefreshed(token) {
    refreshSubscribers.map(cb => cb(token));
    refreshSubscribers = [];
}


async function refreshToken() {
    try {
        let response = (await fetch(`${BASE_URL}/oauth/token`, {
            headers: {
                'Accept': 'application/json',       // receive json
                'Content-Type': 'application/json',
                "authorization": 'Bearer ' + window.localStorage.getItem('access_token'),
            },
            body: JSON.stringify({
                grant_type: 'refresh_token',
                refresh_token: window.localStorage.getItem('refresh_token'),
                client_id: 2,
                client_secret: CLIENT_SECRET,
                scope: '',
                provider: 'users'
            }),
            method: 'POST'
        }));
        if (response.status === 200) {
            response = await response.json();
            window.localStorage.setItem('access_token', response.access_token);
            window.localStorage.setItem('refresh_token', response.refresh_token);
            return response;
        } else {
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            store.commit('Notification/showError', 'Session has expired . Please re-login to continue');
            await router.push({
                'name': 'Login'
            });
        }


    } catch (e) {
        console.log(e);
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        store.commit('Notification/showError', 'Session has expired . Please re-login to continue');
        await router.push({
            'name': 'Login'
        });
        throw  e;
    }

}
